<template>
  <MoreMoveToCart
    :backToShop="backToShop"
    :discountAmount="discountAmount"
    :aLittleLongerAmount="aLittleLongerAmount"
    :isProvideImmediateDiscount="isProvideImmediateDiscount"
  />
</template>

<script>
import MoreMoveToCart from '@/presentationals/v2/components/layouts/organisms/MoreMoveToCart'

import { Location, MoveType } from '@/plugins/AppManager'
import { isProvideImmediateDiscount } from '../../../../../config/featureProvider'
import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'MoreMoveToCartContainer',
  components: {
    MoreMoveToCart
  },
  computed: {
    discountAmount() {
      const nowPrice = this.$store.getters['cart/totalPrice']
      const targetDiscount = this.$store.getters['cart/nowCartToolTip'](nowPrice)

      if (!targetDiscount) {
        return 0
      }

      return targetDiscount.discountAmount
    },

    aLittleLongerAmount() {
      const nowPrice = this.$store.getters['cart/totalPrice']
      const targetDiscount = this.$store.getters['cart/nowCartToolTip'](nowPrice)

      if (!targetDiscount) {
        return 0
      }

      const result = targetDiscount.tooltip.lessThan - nowPrice

      return result < 0 ? 0 : result
    },

    isProvideImmediateDiscount() {
      const { appVersion, isAndroid } = this.$store.getters

      return isProvideImmediateDiscount({ appVersion, isAndroid })
    }
  },
  methods: {
    backToShopLog() {
      const nowPrice = this.$store.getters['cart/totalPrice']
      const nowDeliveryCharge = this.$store.getters['cart/nowCartDeliveryCharge'](nowPrice)

      const params = {
        DeliveryTip: nowDeliveryCharge ? nowDeliveryCharge.discountDeliveryCharge : 0,
        Price: nowPrice,
        ShopNo: this.$store.getters['baeminShopNo'],
        ToolTip: this.aLittleLongerAmount !== 0
      }

      // M1-6
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_CART,
        type: LogType.CLICK,
        group: LogGroup.CART_DET,
        event: LogEvent.MORE,
        params
      })
    },

    backToShop() {
      this.backToShopLog()
      this.$appManager.move(Location.SHOP, this.$store.getters.isAndroid, MoveType.REPLACE, {
        market_cartToolTip: false,
        market_shopNo: this.$store.getters.baeminShopNo
      })
    }
  }
}
</script>
